import { config } from '../config';
import { makeApiRequest_AppJson } from './common-apiService';

export const fetchGitIotSamplingData = async () => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

// SamplingLevelN_FwConfiguration

export const fetchSamplingLevelN_FwConfigurations_byFwId = async (accessToken, frameworkId) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/levelN-configurations/?frameworkId=${frameworkId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const deleteSamplingLevelN_FwConfiguration = async (accessToken, samplingLevelNFwConfigId) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/levelN-configurations/${samplingLevelNFwConfigId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const saveNewSamplingLevelN_FwConfiguration = async (accessToken, iotLevelN_FwConfigDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/levelN-configurations/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, iotLevelN_FwConfigDTO);
}

export const updateSamplingLevelN_FwConfiguration = async (accessToken, iotLevelN_FwConfigDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/levelN-configurations/${iotLevelN_FwConfigDTO.samplingLevelNFwConfigId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, iotLevelN_FwConfigDTO);
}

// SENSORS / SOURCES

export const fetchOrganizationSensors = async (accessToken, orgUUID, fwId = 1) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sensor-configs/${orgUUID}?fwId=${fwId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchOrganizationSensorsByOrgUUID = async (accessToken, orgUUID) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sensor-configs/${orgUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const saveNewSensor = async (accessToken, orgUUID, sensorDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sensor-configs/${orgUUID}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, sensorDTO);
}

export const deleteSensor = async (accessToken, orgUUID, sensorId) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sensor-configs/${orgUUID}/${sensorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const updateSensor = async (accessToken, orgUUID, sensorDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sensor-configs/${orgUUID}/${sensorDTO.sourceConfigId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, sensorDTO);
}

// SAMPLING CONFIGURATIONS 

export const saveNewSamplingConfiguration = async (accessToken, orgUUID, samplingConfigurationDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sampling-configs/${orgUUID}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, samplingConfigurationDTO);
}

export const updateSamplingConfiguration = async (accessToken, orgUUID, areaIndicatorId, samplingConfigurationDTO) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sampling-configs/${orgUUID}/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, samplingConfigurationDTO);
}

export const getAreaIndicatorSamplingConfiguration = async (accessToken, orgUUID, areaIndicatorId) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sampling-configs/${orgUUID}/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const deleteSamplingConfiguration = async (accessToken, orgUUID, areaIndicatorId) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sampling-configs/${orgUUID}/${areaIndicatorId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const getAreaIndicatorSamplingBySourceId = async (accessToken, sourceConfigId, getAreaIndicatorDTO = false) => {
    const url = `${config.baseB2B_URL}/b2b/sampling/iot/meraki/sampling-configs/source/${sourceConfigId}?getAreaIndicatorDTO=${getAreaIndicatorDTO}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}